// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2s3tp","notes":"Notes_notes__104q7","note":"Notes_note__1aw2r","markdown":"Notes_markdown__2Be7r"};